import {
  Box,
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Fade,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  TextField,
  Typography
} from '@mui/material';
import { Close } from 'mdi-material-ui';
import { forwardRef, useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { apiService } from '../../api/axiosClient';


const Transition = forwardRef((props, ref) => <Fade ref={ref} {...props} />)

const DialogMainCategory = (props) => {
  const { show, setShow, setReload } = props
  const [loading, setLoading] = useState(false)
  const [files, setFiles] = useState([])
  const defaultValues = {
    title: '',
    subtitle: '',
    link: '',
    showorder: 0
  }
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({ defaultValues })

  useEffect(() => {
    if(!show) {
      reset(defaultValues);
      setFiles([]);
    }
  },[show])

  const onSubmit = async (data, e) => {
    setLoading(true)

    const formData = new FormData();

    formData.append('title', data.title);
    formData.append('subtitle', data.subtitle);
    formData.append('link', data.link);
    formData.append('showorder', data.showorder);

    try {
      await apiService.postFormData('/maincategory', formData);
      toast.success('업데이트 되었습니다.');
      setReload(reload => reload + 1);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShow(false);
    }
  }

  return (
    <Card>
      <Dialog
        fullWidth
        open={show}
        maxWidth='md'
        scroll='body'
        onClose={() => setShow(false)}
        TransitionComponent={Transition}
        onBackdropClick={() => setShow(false)}
      >
        <form onSubmit={handleSubmit(onSubmit)} id="categoryform">
          <DialogContent sx={{ pb: 3, px: { xs: 8, sm: 15 }, pt: { xs: 4, sm: 8 }, position: 'relative' }}>
            <IconButton
              size='small'
              onClick={() => setShow(false)}
              sx={{ position: 'absolute', right: '1rem', top: '1rem' }}
            >
              <Close />
            </IconButton>
            <Box sx={{ mb: 4, textAlign: 'center' }}>
              <Typography variant='h5' sx={{ mb: 3, lineHeight: '2rem' }}>
                Key Product 추가
              </Typography>
            </Box>

            <Grid container spacing={6}>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <Controller
                    name='title'
                    control={control}
                    rules={{ required: true }}
                    defaultValue=""
                    render={({ field: { value, onChange } }) => (
                      <TextField
                        value={value}
                        label='제목'
                        id='title'
                        onChange={onChange}
                        placeholder='제목을 입력해주세요'
                        error={Boolean(errors.title)}
                        aria-describedby='validation-async-title'
                        variant="standard"
                      />
                    )}
                  />
                  {errors.title && (
                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-title'>
                      필수
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth>
                  <Controller
                    name='subtitle'
                    control={control}
                    rules={{ required: true }}
                    defaultValue=""
                    render={({ field: { value, onChange } }) => (
                      <TextField
                        value={value}
                        label='부제목'
                        id='subtitle'
                        onChange={onChange}
                        placeholder='부제목을 입력해주세요'
                        error={Boolean(errors.subtitle)}
                        aria-describedby='validation-async-subtitle'
                        variant="standard"
                      />
                    )}
                  />
                  {errors.subtitle && (
                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-subtitle'>
                      필수
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth>
                  <Controller
                    name='link'
                    control={control}
                    rules={{ required: true }}
                    defaultValue=""
                    render={({ field: { value, onChange } }) => (
                      <TextField
                        value={value}
                        label='URL'
                        id='link'
                        onChange={onChange}
                        placeholder='URL 링크를 입력해주세요'
                        error={Boolean(errors.link)}
                        aria-describedby='validation-async-link'
                        variant="standard"
                      />
                    )}
                  />
                  {errors.link && (
                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-link'>
                      필수
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth>
                  <Controller
                    name='showorder'
                    control={control}
                    rules={{ required: true }}
                    defaultValue=""
                    render={({ field: { value, onChange } }) => (
                      <TextField
                        value={value}
                        label='순서'
                        id='showorder'
                        onChange={onChange}
                        placeholder='순서를 입력해주세요'
                        error={Boolean(errors.showorder)}
                        aria-describedby='validation-async-showorder'
                        variant="standard"
                      />
                    )}
                  />
                  {errors.showorder && (
                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-showorder'>
                      필수
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>

            </Grid>
          </DialogContent>
        </form>

        <DialogActions sx={{ pb: { xs: 4, sm: 8 }, justifyContent: 'center' }}>
          <Button type="submit" form="categoryform" variant='contained'>
            {loading ? (
              <CircularProgress
                sx={{
                  color: 'common.white',
                  width: '20px !important',
                  height: '20px !important',
                  mr: theme => theme.spacing(2)
                }}
              />
            ) : null}
            등록
          </Button>
          <Button variant='outlined' color='secondary' onClick={() => setShow(false)}>
            취소
          </Button>
        </DialogActions>

      </Dialog>
    </Card>
  )
}

export default DialogMainCategory
